import head from 'lodash/head';
import last from 'lodash/last';
import { IMG_POSTFIX } from '@yme/utils/constants';
import { formatPrice } from '@yme/utils/formatPrice';
export function getProductCardImage(image) {
    if (image) {
        return image.replace(IMG_POSTFIX.thumbnail, IMG_POSTFIX.mobile);
    }
    return '';
}
export function getPricesValues(language, currency_code, variantWithLowestPrice) {
    if (!variantWithLowestPrice || !variantWithLowestPrice.price_variant || !currency_code) {
        return {
            priceValue: undefined,
            discountedPrice: undefined,
        };
    }
    const { price_variant, sale_price_variant } = variantWithLowestPrice;
    const priceValue = formatPrice({
        locale: language,
        currencyName: currency_code,
        price: head(price_variant),
    });
    const discountedValue = head(sale_price_variant) && head(sale_price_variant) !== head(price_variant)
        ? formatPrice({
            locale: language,
            currencyName: currency_code,
            price: head(sale_price_variant),
        })
        : undefined;
    return {
        priceValue,
        discountedValue,
    };
}
export const getVariantWithAvailableLowestPrise = (variants) => {
    const minPricesArr = [];
    const minPrice = variants.reduce((min, item) => {
        const minItemPrice = head(item.sale_price_variant) || head(item.price_variant) || Infinity;
        if (minItemPrice && min > minItemPrice) {
            min = minItemPrice;
        }
        minPricesArr.push(minItemPrice);
        return min;
    }, Infinity);
    const variantWithLowestPrice = variants.find((item) => head(item.price_variant) === minPrice || head(item.sale_price_variant) === minPrice);
    const isLowestPriseExist = variantWithLowestPrice
        ? !minPricesArr.every((item) => minPrice === item)
        : false;
    return {
        variantWithLowestPrice: !variantWithLowestPrice || !isLowestPriseExist
            ? last(variants) || head(variants)
            : variantWithLowestPrice,
        isLowestPriseExist,
    };
};
